import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../services/authentication.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'upload-transcode-live',
	templateUrl: './upload-transcode-live.component.html',
	styleUrls: ['./upload-transcode-live.component.scss']
})

export class UploadTranscodeLiveComponent implements OnInit, OnDestroy {
	subscriptions: Subscription;
	liveStreamType: string;

	putRight: boolean;
	liveRight: boolean;

	constructor(private authenticationService: AuthenticationService) {
		this.authenticationService.hasPermission('put').subscribe(hasRight => this.putRight = hasRight);
		this.authenticationService.hasPermission('live').subscribe(hasRight => this.liveRight = hasRight);
		this.subscriptions = new Subscription();
	}

	ngOnInit() { }

	ngOnDestroy() {
		if (this.subscriptions) {
			this.subscriptions.unsubscribe();
		}
	}
}
